import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";

export const PageLayout = (props) => {
  return <>{props.children}</>;
};

PageLayout.propTypes = {
  children: PropTypes.array,
};
